import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=f5683376&scoped=true"
import script from "./UserUpdate.vue?vue&type=script&lang=ts"
export * from "./UserUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5683376",
  null
  
)

export default component.exports